import { Component, OnInit, HostListener, ViewChild, AfterViewInit, EventEmitter, Output } from "@angular/core";
import { PackageDataService } from "../../data-services/package.service";
import { DialogService } from "primeng/dynamicdialog";
import { RequisitionDataService } from "../../data-services/requisition.service";
import { DatePipe } from "@angular/common";
import { MessageService } from "primeng/api";
import { ComponentCanDeactivate } from "../../helpers/pending-changes.guard";
import { Observable } from "rxjs";
import { ConfirmationService } from "primeng/api";
import { LookupService } from "../../data-services/lookup.service";
import { RequisitionIntakeDataService } from "../../data-services/requisitionIntake.service";
import { Howl } from 'howler';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: "intervenn-sample-receive",
  templateUrl: "./intervenn.sample.receive.html",
  styleUrls: ["./intervenn.sample.receive.css"],
  providers: [DialogService, DatePipe, MessageService, ConfirmationService],
  imports: [ButtonModule, Dialog, FormsModule, ConfirmDialog, Toast, CommonModule, TableModule, RadioButtonModule ]
})
export class IntervennSampleReceiveComponent implements OnInit, AfterViewInit {
  @Output() onSampleReceived = new EventEmitter<any>();

  @ViewChild("ordersearch")
  searchBox;

  order: any = {};
  showSpinner = false;
  loading = false;
  orderSearch: string;
  specimenTypes: any[];

  showNameConfirmDialog = false;

  constructor(private requisitionIntakeService: RequisitionIntakeDataService,
    private lookupService: LookupService,
    public dialogService: DialogService,
    public datepipe: DatePipe,
    private messageService: MessageService) {
  }

  @ViewChild("sampleForm")
  sampleForm: any;

  ngOnInit() {
    this.lookupService.getSpecimenTypes().subscribe((data: any) => {
      this.specimenTypes = data;
    });
  }

  ngAfterViewInit() {
    this.searchBox.nativeElement.focus();
  }

  //Barcode scanning/entry handling
  barcode = "";
  barcodeReading = false;

  @HostListener("document:keypress", ["$event"])
  handleKeystroke({ keyCode, key }) {
    if (keyCode === 13) {

      if (this.barcodeReading) {
        this.handleBarCode(this.barcode);
      }
      else {
        this.handleBarCode(this.orderSearch);
      }
      this.barcode = "";
    } else {
      //while not an 'enter', store every key    
      this.barcode += key;
    }

    //after a timeout of 200ms on the first read, clear everything
    if (!this.barcodeReading) {
      this.barcodeReading = true;
      setTimeout(() => {
        this.barcode = "";
        this.barcodeReading = false;
      },
        200);
    }
  }

  handleBarCode(code: string) {
    code = code.replace(/[^ -~]+/g, "");

    if (code.length > 5) {

      this.lookupMedtekOrder(code);
    }
    this.orderSearch = "";
  }


  getSpecimenTypeNameByCode(code: string) {
    const specimenType = this.specimenTypes?.find(x => x.Code === code);
    return specimenType?.Name;
  }

  handleSearchButton() {
    this.handleBarCode(this.orderSearch);
  }


  lookupMedtekOrder(accession) {
    this.getMTOrder(accession);
  }

  getMTOrder(accession, originalSerialNumber = null) {
    this.showSpinner = true;
    this.order = {};
    console.log("getting order", accession);
    this.requisitionIntakeService.intervennGetForIntake(accession).subscribe((data: any) => {
      console.log("order response", data);
      this.order = data;
      this.order.SpecimenTypeMatch = true;
      this.order.NameMatch = null;
      this.order.BirthDateMatch = null;
      this.order.PatientSampleObserved = null;
      this.showSpinner = false;
      this.showNameConfirmDialog = true;
    },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Order",
          detail: "Error retrieving sample. Please try again"
        });
        this.showSpinner = false;
      });
  }


  sampleCompleted(success: boolean) {
    this.searchBox.nativeElement.focus();
  }

  closeNameConfirmDialog() {
    const exceptionMessage = "";
    console.log("closing name confirm");
    if (this.order.NameMatch === false || this.order.BirthDateMatch === false) {
      //const orderSource = this.order.OrderSource;
      //const dateReceived = this.order.DateReceived;
      //this.order.Accession = null;
      //this.order.Id = 0;
      //this.order.SpecimenSerialNumber = null;
      //this.order.DateReceived = dateReceived != null ? dateReceived : `${new Date()}`;
      //this.order.OrderSource = orderSource;
      //this.order.Exceptions.push({ IssueDescription: `Label Mismatch` });
      this.order.IsPatientMismatch = true;
      this.order.HasExceptions = true;
    } 
    if (this.order.SpecimenTypeMatch === false) {
      //const orderSource = this.order.OrderSource;
      //const dateReceived = this.order.DateReceived;
      //this.order.Accession = null;
      //this.order.Id = 0;
      //this.order.SpecimenSerialNumber = null;
      //this.order.DateReceived = dateReceived != null ? dateReceived : `${new Date()}`;
      //this.order.OrderSource = orderSource;
      //this.order.Exceptions.push({ IssueDescription: `Label Mismatch` });
      this.order.IsPatientSampleMismatch = true;
      this.order.HasExceptions = true;
    } 

    console.log("saving order", this.order);
    this.requisitionIntakeService.Save(this.order).subscribe((data: any) => {
      this.onSampleReceived.emit();
      this.showNameConfirmDialog = false;
    },
      (err) => {
        this.messageService.add({
          severity: "error",
          summary: "Saving Sample",
          detail: "Error saving sample. Please try again"
        });
        this.showSpinner = false;
      });;
  }

  cancelNameConfirmDialog() {
    this.showNameConfirmDialog = false;
    this.order = {};
  }

}
